<app-navbar></app-navbar>
<router-outlet (activate)="onActivate($event)"></router-outlet>

<app-footer class="sticky-footer" id="sticky"></app-footer>
